export default __webpack_public_path__ + "static/media/Norlics.8d60443d.svg";